import React, { memo } from 'react';

import { Input } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

export type InputProductSearchType = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  value: string;
  handleSearchEnter: (v: string) => void;
};

export const InputProductSearch = memo((props: InputProductSearchType) => {
  return (
    <Input
      id='my-products-search'
      value={props.value}
      suffix={<Icon.Funnel />}
      onChange={props.onChange as any}
      className='mb-4 w-70'
      onKeyPress={props.onKeyPress as any}
      placeholder='Pesquise pelo título ou ID do produto'
    />
  );
});
